/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadCountries } from '@nibtravel/shared/data-access/countries';
import { QuoteActions } from '@nibtravel/shared/data-access/quote';
import { LoadQuoteConfig } from '@nibtravel/shared/data-access/quote-config';
import { UiContentActions } from '@nibtravel/shared/data-access/ui-content';
import {
  AppConfigState,
  AppInitializerService,
} from '@nibtravel/shared/util/app-config';
import { FeatureActions } from '@nibtravel/shared/util/feature-toggle';
import { AppInit } from '@nibtravel/shared/util/models';
import { Observable } from 'rxjs';
import { concatMapTo, switchMap, take } from 'rxjs/operators';

export const QqcAppFactory =
  (common: AppInitializerService, app: QqcAppInitializer): AppInit =>
  () =>
    common.init().pipe(concatMapTo(app.init())); // TODO: Change when Rxjs 7 use concatWith

@Injectable()
export class QqcAppInitializer {
  constructor(private store: Store) {}

  init(): Observable<any> {
    return this.store.select(AppConfigState.getState).pipe(
      switchMap(({ brand, stage, campaignCode }) => {
        const actions: any = [
          new LoadQuoteConfig(brand),
          new FeatureActions.Init(brand, stage),
          new LoadCountries(brand),
          new UiContentActions.LoadBrandContent(brand),
        ];
        if (campaignCode) {
          actions.push(new QuoteActions.SetDefaultCampaignCode(campaignCode));
        }
        return this.store.dispatch(actions);
      }),
      take(1)
    );
  }
}
